import { LineChart as LineChartPrimitive } from '@zippeditoolsjs/dashboards';
import { Box, Typography } from '@mui/material';

/**
 * Generic LineChart wrapper using Tremor via @zippeditoolsjs/dashboards.
 *
 * Props:
 *   data        - array of data objects
 *   indexKey    - field name for the x-axis (Tremor's "index")
 *   valueKeys   - array of field names for the lines (Tremor's "categories")
 *   colors      - array of Tremor color strings
 *   xLabel      - optional x-axis label (display only)
 *   yLabel      - optional y-axis label (display only)
 *   title       - optional chart title
 *   tremorConfig - any extra props spread directly onto LineChart
 */
export default function LineChart(props) {
  const {
    data,
    indexKey,
    valueKeys = [],
    colors,
    xLabel,
    yLabel,
    title,
    tremorConfig = {},
  } = props;

  if (!data || data.length === 0) return null;

  return (
    <Box>
      {title && (
        <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 1 }}>
          {title}
        </Typography>
      )}
      <LineChartPrimitive
        data={data}
        index={indexKey}
        categories={valueKeys}
        colors={colors}
        yAxisWidth={48}
        {...tremorConfig}
      />
      {xLabel && (
        <Typography variant="caption" sx={{ display: 'block', textAlign: 'center', mt: 0.5 }}>
          {xLabel}
        </Typography>
      )}
    </Box>
  );
}
